// import Alpine from "alpinejs";
import SVGInjector from "svg-injector";

window.is_mobile = function () {
    var check = false;
    (function (a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true; })(navigator.userAgent || navigator.vendor || window.opera);
    return check;
};

var init_enter = is_mobile() ? "90% 0%" : "80% 0%";

document.addEventListener('alpine:init', () => {

    if (!window.is_wp_admin) {

        Alpine.directive('aos-fade', (el, { value, modifiers, expression }, { Alpine, effect, evaluate, evaluateLater, cleanup }) => {
            var ep = expression ? evaluate(expression) : {};
            var ani = {};
            var distance = 32;
            switch (value) {
                case 'up': ani = { y: [distance, 0] }; break;
                case 'right': ani = { x: [-distance, 0] }; break;
                case 'down': ani = { y: [-distance, 0] }; break;
                case 'left': ani = { x: [distance, 0] }; break;
                default: ani = { y: [distance, 0] }; break;
            }

            animate(el, {
                opacity: [0, 1],
                ...ani,
                delay: ep.delay || 0,
                autoplay: onScroll({
                    enter: ep.enter || init_enter,
                }),
            });
        });

        Alpine.directive('aos-custom', (el, { value, modifiers, expression }, { Alpine, effect, evaluate, evaluateLater, cleanup }) => {
            var expr = expression ? evaluate(expression) : {};
            animate(el, {
                ...expr,
                autoplay: onScroll({
                    enter: expr.enter ?? init_enter,
                })
            });
        });

        Alpine.directive('aos-clip-line-up', (el, { value, modifiers, expression }, { Alpine, effect, evaluate, evaluateLater, cleanup }) => {
            var expr = expression ? evaluate(expression) : {};

            text.splitText(el, { lines: { wrap: 'clip' }, words: false, chars: false })
                .addEffect(({ lines }) => {
                    animate(lines, {
                        y: ['100%', '0%'],
                        delay: stagger(150, { start: expr.delay ?? 0 }),
                        autoplay: onScroll({
                            enter: expr.enter ?? init_enter,
                            // debug: true
                        })
                    });
                });
        });

        Alpine.directive('aos-count-up', (el, { value, modifiers, expression }, { Alpine, effect, evaluate, evaluateLater, cleanup }) => {
            var expr = expression ? evaluate(expression) : {};
            var enter = expr.enter || init_enter;

            var val = parseInt(el.textContent) || 0;
            animate(el, {
                innerHTML: [0, val],
                delay: expr.delay || 0,
                modifier: v => v.toFixed(0),
                duration: expr.duration || 3000,
                autoplay: onScroll({
                    target: el,
                    enter: enter
                }),
            });
        });

        Alpine.directive('clip-scale', (el, { value, modifiers, expression }, { Alpine, effect, evaluate, evaluateLater, cleanup }) => {
            var expr = expression ? evaluate(expression) : {};
            var wrapper = document.createElement('div');
            el.parentNode.insertBefore(wrapper, el);
            wrapper.appendChild(el);
            wrapper.style.overflow = 'hidden';
            wrapper.style.willChange = 'clip-path, transform';

            const tl = createTimeline({
                autoplay: onScroll({
                    target: wrapper,
                    ...expr,
                    // debug: true
                }),
            });
            tl.add( wrapper , {
                duration: 1500,
                clipPath: 
                    value =='left' ? ['polygon(0% 0%, 0% 0%, 0% 100%, 0% 100%)', 'polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)'] :
                    value =='right' ? ['polygon(100% 0%, 100% 0%, 100% 100%, 100% 100%)', 'polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)'] :
                    value =='up' ? ['polygon(0% 100%, 100% 100%, 100% 100%, 0% 100%)', 'polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)'] :
                                    ['polygon(0% 0%, 100% 0%, 100% 0%, 0% 0%)', 'polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)'] 
            }).add(el, {
                scale: [1.5, 1],
                duration: 3000,
            }, '<<');
        });
    }

    Alpine.directive('hover-bg-animation', (el, { value, modifiers, expression }, { Alpine, effect, evaluate, evaluateLater, cleanup }) => {
        var expr = expression ? evaluate(expression) : {};

        const getHoverDirection = function (event) {
            var directions = ['top', 'right', 'bottom', 'left'];
            var item = event.currentTarget;

            // Width and height of current item
            var w = item.offsetWidth;
            var h = item.offsetHeight;

            // Calculate the x/y value of the pointer entering/exiting, relative to the center of the item.
            // Scale (sort of normalize) the coordinate on smallest side to the scale of the longest.
            var x = (event.clientX - item.getBoundingClientRect().left - (w / 2)) * (w > h ? (h / w) : 1);
            var y = (event.clientY - item.getBoundingClientRect().top - (h / 2)) * (h > w ? (w / h) : 1);

            // Calculate the angle to the center the pointer entered/exited
            // and convert to clockwise format (top/right/bottom/left = 0/1/2/3).
            var d = Math.round(Math.atan2(y, x) / 1.57079633 + 5) % 4;

            return directions[d];
        };

        // Loop over the registered event types.
        ['mouseenter', 'mouseleave'].forEach(function (eventname) {
            el.addEventListener(eventname, function (event) {

                // Retrieve the direction of the enter/leave event.
                var dir = getHoverDirection(event);

                // Reset classes.
                event.currentTarget.classList.remove('mouseenter');
                event.currentTarget.classList.remove('mouseleave');
                event.currentTarget.classList.remove('top');
                event.currentTarget.classList.remove('right');
                event.currentTarget.classList.remove('bottom');
                event.currentTarget.classList.remove('left');

                // Add the event and direction classes.
                event.currentTarget.className += ' ' + event.type + ' ' + dir;

            }, false);
        });

        if (el.querySelectorAll('.ani-clip-down').length) {
            el.addEventListener('mouseenter', () => {
                animate(el.querySelectorAll('.ani-clip-down'), {
                    clipPath: ['polygon(0% 100%, 100% 100%, `100% 100%, 0% 100%)', 'polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)'],
                    y: ['-100%', '0%'],
                    delay: stagger(150, { start: 0 })
                });
            });

            el.addEventListener('mouseleave', () => {
                animate(el.querySelectorAll('.ani-clip-down'), {
                    clipPath: ['polygon(0% 100%, 100% 100%, 100% 100%, 0% 100%)', 'polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)'],
                    y: ['-100%', '0%'],
                    delay: stagger(150, { start: 0 })
                });
            });
        }
    });

    Alpine.directive('hover-work-animation', (el, { value, modifiers, expression }, { Alpine, effect, evaluate, evaluateLater, cleanup }) => {
        var expr = expression ? evaluate(expression) : {};

        var anim = null;
        el.addEventListener('mouseenter', () => {
            var hoverEl = el.querySelector('.work-card-img-hover');
            var height = hoverEl.querySelector('img').getBoundingClientRect().height - el.querySelector('.work-card-img').getBoundingClientRect().height - 1;
            animate(hoverEl, {
                opacity: [0, 1],
            });
            anim = animate(hoverEl, {
                y: [0, -height],
                delay: 200,
                duration: 8000,
                ease: 'inOutQuad',
                loopDelay: 200,
                loop: true,
                alternate: true
            });
        });
        el.addEventListener('mouseleave', () => {
            var hoverEl = el.querySelector('.work-card-img-hover');
            animate(hoverEl, { opacity: [1, 0], });
            anim.cancel();
        });
    });

    Alpine.directive('collapse', (el, { value, modifiers, expression }, { Alpine, effect, evaluate, evaluateLater, cleanup }) => {
        var wrapper = document.createElement('div');
        wrapper.style.overflow = 'hidden';
        wrapper.style.willChange = 'height';
        // insert wrapper before el in the DOM tree
        el.parentNode.insertBefore(wrapper, el);
        // move el into wrapper
        wrapper.appendChild(el);
        wrapper.style.height = modifiers.indexOf('show') > -1 ? '' : 0;
        
        let handle = evaluateLater(expression);

        
        effect(() => {
            handle(val => {
                const _style = getComputedStyle(el);
                let _height = el.offsetHeight +
                    parseFloat(_style.marginTop) +
                    parseFloat(_style.marginBottom);
                animate(wrapper, {
                    height: val ? _height : 0,
                    onComplete: () => {
                        if (val) wrapper.style.height = "";
                    }
                });
            })
        });
    })

    Alpine.directive('duplicate', (el, { value, modifiers, expression }, { Alpine, effect, evaluate, evaluateLater, cleanup }) => {
        el.appendChild(el.children[0].cloneNode(true));
    });

    Alpine.directive('svg-inline', (el, { value, modifiers, expression }, { Alpine, effect, evaluate, evaluateLater, cleanup }) => {
        SVGInjector(el);
    });

    if (OverlayScrollbarsGlobal) {
        var {
            OverlayScrollbars,
            ScrollbarsHidingPlugin,
            SizeObserverPlugin,
            ClickScrollPlugin
        } = OverlayScrollbarsGlobal;

        Alpine.directive('scrollbar', (el, { value, modifiers, expression }, { Alpine, effect, evaluate, evaluateLater, cleanup }) => {
            OverlayScrollbars(el, {
                scrollbars: {
                    theme: 'os-theme-light',
                    visibility: 'auto',
                    autoHide: 'scroll',
                },
            });
        });
    }

});

document.addEventListener('DOMContentLoaded', () => {
    // Initialize Lenis
    if (typeof Lenis !== 'undefined') {
        const lenis = new Lenis({
            autoRaf: true,
        });

        window.lenis = lenis; // Make Lenis globally accessible
    }

    // Rellax
    if (typeof Rellax !== 'undefined' && document.querySelectorAll('[rellax]').length) {
        // Initialize Rellax
        const rellax = new Rellax('[rellax]', {
            speed: -3,
            center: true,
            round: true,
            vertical: true,
            horizontal: false,
        });

        window.rellax = rellax; // Make Rellax globally accessible
    }
});
